import { IStepHeadingProps } from "./step-heading.models";

/** The badge, title and one line of reassurance both steps open with. */
export const StepHeading = ({
  icon,
  title,
  description,
}: IStepHeadingProps) => (
  <>
    <span className="flex size-11 items-center justify-center rounded-xl bg-brand-50 text-brand-600 ring-1 ring-brand-500/15 ring-inset">
      {icon}
    </span>
    <h1 className="mt-4 text-2xl font-semibold tracking-tight text-ink-900">
      {title}
    </h1>
    <p className="mt-2 text-sm/6 text-pretty text-ink-500">{description}</p>
  </>
);
